import DarkMode from "../DarkMode";
import React from "react";
import Header from "./Header";

export default function () {
    return (
        <>
            <div>
                <Header/>
            </div>
        </>
    )
}